import { FlagsComponentRouter } from 'flags'
import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-26293-experience-player-in-learn'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
